import { render, staticRenderFns } from "./become.vue?vue&type=template&id=622ebc0c&scoped=true&"
import script from "./become.vue?vue&type=script&lang=js&"
export * from "./become.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../shared/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "622ebc0c",
  null
  
)

export default component.exports